// pages/AgentAssistGpt4o.js
import { useState, useEffect, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

// Hardcoded URL
const EXTERNAL_URL = "http://10.3.102.114:8080/";

const AgentAssistGpt4o = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const iframeRef = useRef(null);

  const { user } = useContext(AuthContext);
  const location = useLocation();

  // Replay entry animations on route change
  useEffect(() => {
    setIsLoaded(false);
    const t = setTimeout(() => setIsLoaded(true), 50);
    return () => clearTimeout(t);
  }, [location.pathname]);

  const handleFullscreen = () => {
    const el = iframeRef.current;
    if (!el) return;
    (el.requestFullscreen ||
      el.webkitRequestFullscreen ||
      el.msRequestFullscreen ||
      el.mozRequestFullScreen)?.call(el);
  };

  const renderUserProfile = () => (
    <div className="flex items-center">
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-300 dark:bg-gray-700 flex items-center justify-center text-sm font-medium text-gray-700 dark:text-gray-200 mr-2">
        {user?.name
          ? user.name.charAt(0).toUpperCase()
          : user?.username
          ? user.username.charAt(0).toUpperCase()
          : "G"}
      </div>
      <div className="flex flex-col">
        <div className="font-medium text-sm dark:text-white">
          {user?.name || user?.username || "Guest"}
        </div>
        {user && (
          <div className="text-xs text-gray-500 dark:text-gray-400">
            {user?.department && `${user.department} • `}
            {user?.role || "User"}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="flex-1 flex flex-col h-full overflow-hidden">
      <div className="flex-grow overflow-y-auto px-2 md:px-4 py-3">
        <div
          className={`bg-white bg-opacity-60 dark:bg-white dark:bg-opacity-10 rounded-lg p-4 h-full flex flex-col transition-all duration-500 ${
            isLoaded ? "opacity-100" : "opacity-0"
          }`}
        >
          {/* Header (maximize only + profile) */}
          <div
            className={`flex justify-between border-b border-gray-200 dark:border-gray-700 mb-4 transition-all duration-500 delay-100 ${
              isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div className="flex">
              <div className="flex items-center px-4 py-2 border-b-2 border-gray-800 dark:border-uasYellow text-gray-800 dark:text-white font-medium">
                AI Arena
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={handleFullscreen}
                className="p-2 text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors"
                title="Fullscreen"
                aria-label="Fullscreen"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                  />
                </svg>
              </button>

           
            </div>
          </div>

          {/* Iframe container */}
          <div
            className={`w-full bg-white dark:bg-laryzeDarkGray dark:bg-opacity-90 rounded-lg shadow flex flex-col h-full transition-all duration-500 delay-200 ${
              isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="flex-1 border-t-8 rounded-t-md border-t-black dark:border-t-uasYellow overflow-hidden">
              {hasError ? (
                <div className="flex items-center justify-center h-full text-center p-8">
                  <div className="max-w-md">
                    <svg
                      className="w-16 h-16 mx-auto text-red-500 mb-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                      Unable to Connect
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400">
                      Could not load the external application at {EXTERNAL_URL}
                    </p>
                  </div>
                </div>
              ) : (
                <iframe
                  ref={iframeRef}
                  id="external-webview"
                  src={EXTERNAL_URL}
                  className="w-full h-full border-none"
                  title="External Application"
                  allowFullScreen
                  onLoad={() => setHasError(false)}
                  onError={() => setHasError(true)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentAssistGpt4o;
